import React, { Component } from "react"
import withStyles from "@material-ui/styles/withStyles"
import Grid from "@material-ui/core/Grid"

import ScheduleTable from "../../../components/Table/ScheduleTable"
import SectionHeader from "../../../components/SectionHeader"

import rebase from "../../../config/rebase"
import { Button } from "@material-ui/core"
import { dbPrefix, knowledgeAreaArray } from "../../../Constants"
import { Link } from "react-router-dom"
import Wrapper from "../../../components/Common/Wrapper"

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: '30px',
  },
  grid: {
    width: 1200,
    marginTop: 40,
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 20px)"
    }
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: "left",
    color: theme.palette.text.secondary
  },
  rangeLabel: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2)
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 32
  },
  outlinedButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1)
  },
  actionButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1),
    width: 152
  },
  blockCenter: {
    padding: theme.spacing(2),
    textAlign: "center"
  },
  block: {
    padding: theme.spacing(2)
  },
  box: {
    marginBottom: 40,
    height: 65
  },
  inlining: {
    display: "inline-block",
    marginRight: 10
  },
  buttonBar: {
    display: "flex"
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end"
  },
  noBorder: {
    borderBottomStyle: "hidden"
  },
  loadingState: {
    opacity: 0.05
  },
  loadingMessage: {
    position: "absolute",
    top: "40%",
    left: "40%"
  }
})

class MyPapers extends Component {

  state = {
    learnMoredialog: false,
    getStartedDialog: false,
    fatalError: false,
    loaded: false,
    papers: []
  }

  columns = [
    {
      name: "paperTitle",
      label: "Nome",
      options: {
        filter: false
      }
    },
    {
      name: "knowledgeArea",
      label: "Área de Conhecimento",
      options: {
        customBodyRender: (val) => {
          const area = knowledgeAreaArray.find(k => val === k.value)
          return <span>{area.title}</span>
        }
      }
    },
    {
      name: "Visualizar",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (index) => {
          return (
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              component={Link}
              to={"/meu-trabalho/" + this.state.papers[index].key}>
              &#8594;
            </Button>
          )
        }
      }
    }

  ];

  componentDidMount() {
    const { user } = this.props

    rebase.fetch(dbPrefix + 'papers', {
      asArray: true,

    }).then(data => {
      if (!data.length) {
        return this.setState({ fatalError: "Não há trabalhos cadastrados." })
      }

      // Filtrando todos os papers ... RTDB não tem suporte para array filter
      const papers = data.filter(p => p.usersId.includes(user.ucpf.toString()))
      if (!papers.length) {
        return this.setState({ fatalError: "Não há trabalhos cadastrados para você." })
      }
      this.setState({ papers })

    }).catch(error => {
      console.log(error)
      this.setState({ fatalError: 'Ocorreu um erro' })

    }).finally(() => {
      this.setState({ loaded: true })
    })
  }

  render() {
    const { classes } = this.props

    return (

      <Wrapper loaded={this.state.loaded} fatalError={this.state.fatalError} currentPath={this.props.location.pathname} subscribedTopbar>
        <Grid container justify="center">
          <Grid
            alignItems="center"
            justify="center"
            container
            className={classes.grid}
          >
            <Grid item xs={12}>
              <SectionHeader
                title="Meus Trabalhos"
                subtitle="A tabela abaixo lista todos os seus trabalhos"
              />
              <ScheduleTable data={this.state.papers} columns={this.columns} title={"Meus Trabalhos"} />
            </Grid>
          </Grid>
        </Grid>

      </Wrapper>
    )
  }
}
export default withStyles(styles)(MyPapers)
